import { RelocationOrderStatus } from "@/api-schema-enums";

export const REJECTION_STATUSES: RelocationOrderStatus[] = [
  RelocationOrderStatus.TransportCompanyRejectedDamagedVehicle,
  RelocationOrderStatus.TransportCompanyRejectedMissingVehicle,
  RelocationOrderStatus.TransportCompanyRejectedMissingKeys,
];

export const getStatusColor = (status: RelocationOrderStatus): string => {
  switch (status) {
    case "Branch_Awaiting_Pickup":
      return "bg-gray-400 hover:bg-gray-500";
    case "Transport_Company_In_Transit":
      return "bg-success hover:bg-success/90";
    case "Transport_Company_Rejected_Damaged_Vehicle":
    case "Transport_Company_Rejected_Missing_Vehicle":
    case "Transport_Company_Rejected_Missing_Keys":
      return "bg-error hover:bg-error/90";
    default:
      return "bg-gray-400 hover:bg-gray-500";
  }
};

export const isRejectionStatus = (status: RelocationOrderStatus): boolean => {
  return REJECTION_STATUSES.includes(status);
};

export const getNextLoadStatus = (currentStatus: RelocationOrderStatus): RelocationOrderStatus => {
  switch (currentStatus) {
    case RelocationOrderStatus.BranchAwaitingPickup:
      return RelocationOrderStatus.TransportCompanyInTransit;
    case RelocationOrderStatus.TransportCompanyInTransit:
      return RelocationOrderStatus.TransportCompanyRejectedDamagedVehicle;
    default:
      return RelocationOrderStatus.BranchAwaitingPickup;
  }
};
